"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralEnquiryInputDtoQueryEnum = void 0;
exports.instanceOfGeneralEnquiryInputDto = instanceOfGeneralEnquiryInputDto;
exports.GeneralEnquiryInputDtoFromJSON = GeneralEnquiryInputDtoFromJSON;
exports.GeneralEnquiryInputDtoFromJSONTyped = GeneralEnquiryInputDtoFromJSONTyped;
exports.GeneralEnquiryInputDtoToJSON = GeneralEnquiryInputDtoToJSON;
exports.GeneralEnquiryInputDtoToJSONTyped = GeneralEnquiryInputDtoToJSONTyped;
/**
 * @export
 */
exports.GeneralEnquiryInputDtoQueryEnum = {
    PropertyListing: 'property_listing',
    Campaign: 'campaign',
    AccountDelete: 'account_delete',
    Other: 'other'
};
/**
 * Check if a given object implements the GeneralEnquiryInputDto interface.
 */
function instanceOfGeneralEnquiryInputDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('query' in value) || value['query'] === undefined)
        return false;
    if (!('details' in value) || value['details'] === undefined)
        return false;
    return true;
}
function GeneralEnquiryInputDtoFromJSON(json) {
    return GeneralEnquiryInputDtoFromJSONTyped(json, false);
}
function GeneralEnquiryInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'email': json['email'],
        'query': json['query'],
        'listingId': json['listingId'] == null ? undefined : json['listingId'],
        'details': json['details'],
    };
}
function GeneralEnquiryInputDtoToJSON(json) {
    return GeneralEnquiryInputDtoToJSONTyped(json, false);
}
function GeneralEnquiryInputDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'email': value['email'],
        'query': value['query'],
        'listingId': value['listingId'],
        'details': value['details'],
    };
}
